import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Location } from '@shared/models';
import {
  CreateLocationRequest,
  LocationService,
  UpdateLocationRequest,
} from '@app/resources/services/location.service';

@Injectable()
export class LocationsApiService {
  private readonly locationService = inject(LocationService);

  getByMerchantId(merchantId: number): Observable<Location[]> {
    return this.locationService.findAll(merchantId).pipe(
      map((result: any) => {
        const values = result?.$values ?? [];
        return values.map((data: any) => mapToLocation(data, merchantId));
      })
    );
  }

  getById(locationId: number): Observable<Location | null> {
    return this.locationService
      .findById(locationId)
      .pipe(map((result: any) => (result ? mapToLocation(result) : null)));
  }

  create(createLocationRequest: CreateLocationRequest): Observable<Location | null> {
    return this.locationService
      .create(createLocationRequest)
      .pipe(map((result: any) => (result ? mapToLocation(result, createLocationRequest.MerchantId) : null)));
  }

  update(updateLocationRequest: UpdateLocationRequest): Observable<Location | null> {
    return this.locationService
      .update(updateLocationRequest)
      .pipe(map((result: any) => (result ? mapToLocation(result, updateLocationRequest.MerchantId) : null)));
  }
}

function mapToLocation(data: any, merchantId?: number): Location {
  return {
    LocationId: data.locationId,
    MerchantId: merchantId ?? data.merchantId,
    Name: data.name,
    Address: data.address,
    PhoneNumber: data.phoneNumber != null ? String(data.phoneNumber) : undefined,
    LanguageType: data.languageType ?? undefined,
    CurrencyType: data.currencyType ?? undefined,
    TimeZoneType: data.timeZoneType ?? undefined,
    StatusType: data.statusType ?? undefined,
    Latitude: data.latitude ?? undefined,
    Longitude: data.longitude ?? undefined,
  };
}
